import React, {useState} from 'react'
import {Footer, Possibility, Header} from './containers'
import {CTA, Navbar} from './components'
import './App.css'
import spineAd from './assets/lcpt-spine-ad.jpg'

const App = () => {
  const [showAd, setShowAd] = useState(true)

  return (
    <div className="App">
        {showAd && (
          <div className="lcpt__ad-overlay" role="dialog" aria-modal="true" aria-label="Advanced spine treatment advertisement">
            <div className="lcpt__ad-modal">
              <button className="lcpt__ad-close" type="button" aria-label="Close advertisement" onClick={() => setShowAd(false)}>×</button>
              <img src={spineAd} alt="Advanced spine treatment in Crown Point for back pain, neck pain, sciatica, and non-surgical relief" />
            </div>
          </div>
        )}
        <div className="gradient__bg">
          <Navbar/>
          <Header/>
          <Possibility/>
          <CTA/>
        </div>
        <div className="gradient__bg2">
          <Footer/>
        </div>
    </div>
  )
}

export default App
